import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { DynamicField } from '@totalsoft/rocket-ui';
import { withRights } from 'providers/RightsConsumer';
import { emptyString } from 'constants/emptyConst';
import { defaultDecimalPlaces } from 'constants/numeric';
import { getDynamicFieldControlType } from 'utils/functions';
import { useCallback } from 'react';
import { onDynamicInputChange } from 'utils/propertyChangeAdapters';
import { debounce } from 'lodash';
const DEBOUNCE_DELAY = 500;
const PropertyComponent = ({ idx, item, loadPropertyDetails, onPropertyChange, rights, savedWithMandatoryPropertiesEmpty }) => {
  const handleLoadDetails = debounce(
    useCallback(() => loadPropertyDetails(item.propertyId), [loadPropertyDetails, item]),
    DEBOUNCE_DELAY,
    { leading: true }
  );

  const handleChange = useCallback(
    value => {
      if (value?.toString() !== item.propertyValue) onDynamicInputChange(onPropertyChange(idx)('propertyValue'))(value);
    },
    [idx, item.propertyValue, onPropertyChange]
  );

  return (
    <Grid item key={item.propertyId} xs={12} md={6}>
      <DynamicField
        id={'property_' + idx}
        controlType={getDynamicFieldControlType(item.propertyTypeCode)}
        label={item.propertyName}
        onChange={handleChange}
        value={item.propertyValue || emptyString}
        valueKey='value'
        labelKey='label'
        disabled={rights.readOnlyFull || item.readOnly || !rights.clientPropertiesWrite}
        loadOptions={handleLoadDetails}
        required={item.mandatory && !(rights.readOnlyFull || item.readOnly)}
        inputProps={{ decimalScale: item.decimalPlaces ?? defaultDecimalPlaces }}
        error={
          item.mandatory &&
          !(rights.readOnlyFull || item.readOnly) &&
          (item.propertyValue === emptyString || item.propertyValue === null) &&
          savedWithMandatoryPropertiesEmpty
        }
        simpleValue={true}
      />
    </Grid>
  );
};

PropertyComponent.propTypes = {
  idx: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  loadPropertyDetails: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired,
  savedWithMandatoryPropertiesEmpty: PropTypes.bool.isRequired
};

export default withRights(PropertyComponent);
